import React from 'react';
export function Footer() {
  return <footer className="bg-gray-800 text-white" data-id="element-257">
      <div className="max-w-7xl mx-auto py-12 px-4 sm:px-6 lg:px-8" data-id="element-258">
        <div className="xl:grid xl:grid-cols-3 xl:gap-8" data-id="element-259">
          <div className="space-y-8 xl:col-span-1" data-id="element-260">
            <a href="https://neocube.pro" target="_blank" rel="noopener noreferrer" className="flex items-center hover:opacity-90 transition-opacity" data-id="element-261">
              <span className="text-white font-bold text-xl" data-id="element-262">neocube</span>
              <span className="text-blue-400 text-xl" data-id="element-263">.pro</span>
            </a>
            <p className="text-gray-300 text-base" data-id="element-264">
              IT-Sicherheit für Arztpraxen. §390 SGB V Readiness-Paket für Ihre
              Praxis.
            </p>
            <div className="flex space-x-6" data-id="element-265">
              <a href="#" className="text-gray-400 hover:text-white" data-id="element-266">
                <span className="sr-only" data-id="element-267">LinkedIn</span>
                <svg className="h-6 w-6" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true" data-id="element-268">
                  <path fillRule="evenodd" d="M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm-11 19h-3v-11h3v11zm-1.5-12.268c-.966 0-1.75-.79-1.75-1.764s.784-1.764 1.75-1.764 1.75.79 1.75 1.764-.783 1.764-1.75 1.764zm13.5 12.268h-3v-5.604c0-3.368-4-3.113-4 0v5.604h-3v-11h3v1.765c1.396-2.586 7-2.777 7 2.476v6.759z" clipRule="evenodd" data-id="element-269" />
                </svg>
              </a>
              <a href="#" className="text-gray-400 hover:text-white" data-id="element-270">
                <span className="sr-only" data-id="element-271">Twitter</span>
                <svg className="h-6 w-6" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true" data-id="element-272">
                  <path d="M8.29 20.251c7.547 0 11.675-6.253 11.675-11.675 0-.178 0-.355-.012-.53A8.348 8.348 0 0022 5.92a8.19 8.19 0 01-2.357.646 4.118 4.118 0 001.804-2.27 8.224 8.224 0 01-2.605.996 4.107 4.107 0 00-6.993 3.743 11.65 11.65 0 01-8.457-4.287 4.106 4.106 0 001.27 5.477A4.072 4.072 0 012.8 9.713v.052a4.105 4.105 0 003.292 4.022 4.095 4.095 0 01-1.853.07 4.108 4.108 0 003.834 2.85A8.233 8.233 0 012 18.407a11.616 11.616 0 006.29 1.84" data-id="element-273" />
                </svg>
              </a>
              <a href="#" className="text-gray-400 hover:text-white" data-id="element-274">
                <span className="sr-only" data-id="element-275">Facebook</span>
                <svg className="h-6 w-6" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true" data-id="element-276">
                  <path fillRule="evenodd" d="M22 12c0-5.523-4.477-10-10-10S2 6.477 2 12c0 4.991 3.657 9.128 8.438 9.878v-6.987h-2.54V12h2.54V9.797c0-2.506 1.492-3.89 3.777-3.89 1.094 0 2.238.195 2.238.195v2.46h-1.26c-1.243 0-1.63.771-1.63 1.562V12h2.773l-.443 2.89h-2.33v6.988C18.343 21.128 22 16.991 22 12z" clipRule="evenodd" data-id="element-277" />
                </svg>
              </a>
            </div>
          </div>
          <div className="mt-12 grid grid-cols-2 gap-8 xl:mt-0 xl:col-span-2" data-id="element-278">
            <div className="md:grid md:grid-cols-2 md:gap-8" data-id="element-279">
              <div data-id="element-280">
                <h3 className="text-sm font-semibold text-gray-300 tracking-wider uppercase" data-id="element-281">
                  Lösungen
                </h3>
                <ul className="mt-4 space-y-4" data-id="element-282">
                  <li data-id="element-283">
                    <a href="#" className="text-base text-gray-400 hover:text-white" data-id="element-284">
                      §390 Readiness-Paket
                    </a>
                  </li>
                  <li data-id="element-285">
                    <a href="#" className="text-base text-gray-400 hover:text-white" data-id="element-286">
                      IT-Sicherheit
                    </a>
                  </li>
                  <li data-id="element-287">
                    <a href="#" className="text-base text-gray-400 hover:text-white" data-id="element-288">
                      Datenschutz
                    </a>
                  </li>
                  <li data-id="element-289">
                    <a href="#" className="text-base text-gray-400 hover:text-white" data-id="element-290">
                      Cloud-Lösungen
                    </a>
                  </li>
                </ul>
              </div>
              <div className="mt-12 md:mt-0" data-id="element-291">
                <h3 className="text-sm font-semibold text-gray-300 tracking-wider uppercase" data-id="element-292">
                  Support
                </h3>
                <ul className="mt-4 space-y-4" data-id="element-293">
                  <li data-id="element-294">
                    <a href="#" className="text-base text-gray-400 hover:text-white" data-id="element-295">
                      Preise
                    </a>
                  </li>
                  <li data-id="element-296">
                    <a href="#" className="text-base text-gray-400 hover:text-white" data-id="element-297">
                      Dokumentation
                    </a>
                  </li>
                  <li data-id="element-298">
                    <a href="#" className="text-base text-gray-400 hover:text-white" data-id="element-299">
                      Guides
                    </a>
                  </li>
                  <li data-id="element-300">
                    <a href="#" className="text-base text-gray-400 hover:text-white" data-id="element-301">
                      API Status
                    </a>
                  </li>
                </ul>
              </div>
            </div>
            <div className="md:grid md:grid-cols-2 md:gap-8" data-id="element-302">
              <div data-id="element-303">
                <h3 className="text-sm font-semibold text-gray-300 tracking-wider uppercase" data-id="element-304">
                  Unternehmen
                </h3>
                <ul className="mt-4 space-y-4" data-id="element-305">
                  <li data-id="element-306">
                    <a href="#" className="text-base text-gray-400 hover:text-white" data-id="element-307">
                      Über uns
                    </a>
                  </li>
                  <li data-id="element-308">
                    <a href="#" className="text-base text-gray-400 hover:text-white" data-id="element-309">
                      Blog
                    </a>
                  </li>
                  <li data-id="element-310">
                    <a href="#" className="text-base text-gray-400 hover:text-white" data-id="element-311">
                      Jobs
                    </a>
                  </li>
                  <li data-id="element-312">
                    <a href="#" className="text-base text-gray-400 hover:text-white" data-id="element-313">
                      Partner
                    </a>
                  </li>
                </ul>
              </div>
              <div className="mt-12 md:mt-0" data-id="element-314">
                <h3 className="text-sm font-semibold text-gray-300 tracking-wider uppercase" data-id="element-315">
                  Rechtliches
                </h3>
                <ul className="mt-4 space-y-4" data-id="element-316">
                  <li data-id="element-317">
                    <a href="https://neocube.pro/datenschutz/index.html" className="text-base text-gray-400 hover:text-white" target="_blank" rel="noopener noreferrer" data-id="element-318">
                      Datenschutz
                    </a>
                  </li>
                  <li data-id="element-319">
                    <a href="https://neocube.pro/impressum/index.html" className="text-base text-gray-400 hover:text-white" target="_blank" rel="noopener noreferrer" data-id="element-320">
                      Impressum
                    </a>
                  </li>
                  <li data-id="element-321">
                    <a href="/login" className="text-base text-gray-400 hover:text-white" target="_blank" rel="noopener noreferrer" data-id="element-322">
                      Auditor-Login
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div className="mt-12 border-t border-gray-700 pt-8" data-id="element-323">
          <p className="text-base text-gray-400 xl:text-center" data-id="element-324">
            &copy; 2025 neocube by PEZULA Projects & Experts GmbH - Alle Rechte
            vorbehalten
          </p>
        </div>
      </div>
    </footer>;
}